import * as React from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import GitHubIcon from '@mui/icons-material/GitHub';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" sx={{fontSize:"15px"}}>
      {'Copyright © '}
      Ranko Koturić
      { new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function StickyFooter() {
  return (
   
        <Container maxWidth="sm">
          <Typography variant="body1" sx={{fontSize:"25px"}}>
           Ranko Koturić portfolio page
          <a  href="https://github.com/Ranko1996" target="_blank" style={{color:"black"}}>
              <GitHubIcon sx={{ marginLeft:"20px", height:"40px", width:"40px"}}/>
              </a>
          </Typography>
          <Copyright />
        </Container>
     
  );
}